import moment from "moment";
import myStaysAPI from "../service/mystaysAPI";

const getNightNumber = (night, texts, text) => {
  if (night === 0) return "1 Day";
  return `${night} ${night === 1 ? text : texts}`;
};

const Calendar = {
  configDefault: {
    theme: "windows",
    toText: "",
    buttons: [],
    fromText: "",
    animate: "pop",
    min: new Date(),
    yearChange: false,
    display: "inline",
    minRange: 86400000,
    showSelector: true,
    controls: ["calendar"],
    outerMonthChange: false,
    closeOnOverlayTap: false,
    dateFormat: "yy-mm-dd",
  },
  mobileConfig: {
    months: 1,
    context: "body",
    layout: "liquid",
    calendarScroll: "vertical",
    cssClass: "calendar-mobile",
    scrollLock: false,
  },
  desktopConfig: {
    months: 2,
    calendarScroll: "horizontal",
    cssClass: "calendar-desktop",
    context: ".calendar-desktop",
  },
  text: null,
  inventory: [],
  invalidDate: [],
  disableDate: null,
  getCurrentMonth: (inst) => {
    const totalMonth = inst.markup.querySelectorAll(
      ".mbsc-cal-day-picker .mbsc-cal-table"
    );
    const currentMonths = [totalMonth[1], totalMonth[2]];
    return currentMonths;
  },
  getCurrentDays: (inst) => {
    const currentMonths = Calendar.getCurrentMonth(inst);
    let currentDays = [];

    currentMonths.map((item) => {
      currentDays = [
        ...currentDays,
        ...item.querySelectorAll(
          ".mbsc-cal-row .mbsc-cal-cell:not(.mbsc-disabled)"
        ),
      ];
    });

    return currentDays;
  },
  getInvalidDays: (inst) => {
    const currentMonths = Calendar.getCurrentMonth(inst);
    let invalidDays = [];

    currentMonths.map((item) => {
      invalidDays = [
        ...invalidDays,
        ...item.querySelectorAll(
          '.mbsc-cal-row .mbsc-cal-day:not(.mystays-selected-date):not(.mbsc-disabled):not(.mystays-custom-invalid):not([aria-hidden="true"]'
        ),
      ];
    });

    return invalidDays;
  },
  showToolTip: (inst, text, endVal) => {
    if (text) {
      Calendar.text = text;
    }

    const startDate = inst.startVal;
    const endDate = endVal || inst.endVal || startDate;
    const totalMonth = inst.markup.querySelectorAll(
      ".mbsc-cal-day-picker .mbsc-cal-table"
    );
    const currentMonths = [totalMonth[1], totalMonth[2]];
    let listDate = [];
    currentMonths.map((item) => {
      listDate = [
        ...listDate,
        ...item.querySelectorAll(".mbsc-cal-row .mbsc-cal-cell"),
      ];
    });

    let toolTipContainer;

    listDate.map((day) => {
      const tooltip = day.querySelector(".tool-tip");
      const tooltip1 = day.querySelector(".tool-tip-show-bottom");
      if (tooltip1) {
        day.removeChild(tooltip1);
      }
      if (tooltip) {
        day.removeChild(tooltip);
      }

      const date = day.getAttribute("data-full")
        ? moment(new Date(day.getAttribute("data-full")))
            .format("YYYY/MM/DD")
            .toString()
        : "";

      const end = moment(new Date(endDate))
        .format("YYYY/MM/DD")
        .toString();

      if (date === end) {
        toolTipContainer = day;
      }
    });

    const day = document.querySelector(".mbsc-cal-days-c");
    const numbetNight = moment(endDate).diff(moment(startDate), "days");

    if (
      toolTipContainer &&
      day &&
      toolTipContainer.getBoundingClientRect().y -
        day.getBoundingClientRect().y >
        80
    ) {
      const node = document.createElement("span");
      node.className = "tool-tip";
      if (toolTipContainer.classList.contains("mbsc-cal-day6")) {
        node.classList.add("tool-tip-right");
      } else if (toolTipContainer.classList.contains("mbsc-cal-day0")) {
        node.classList.add("tool-tip-left");
      }
      node.innerHTML = `${getNightNumber(
        numbetNight,
        Calendar.text.nights,
        Calendar.text.night
      )} `;
      toolTipContainer.appendChild(node);
    } else {
      const node = document.createElement("div");
      node.className = "tool-tip-show-bottom";
      if (
        toolTipContainer &&
        toolTipContainer.classList.contains("mbsc-cal-day6")
      ) {
        node.classList.add("tool-tip-right");
      } else if (
        toolTipContainer &&
        toolTipContainer.classList.contains("mbsc-cal-day0")
      ) {
        node.classList.add("tool-tip-left");
      }
      node.innerHTML = `${getNightNumber(
        numbetNight,
        Calendar.text.nights,
        Calendar.text.night
      )}`;
      // eslint-disable-next-line no-unused-expressions
      toolTipContainer ? toolTipContainer.appendChild(node) : null;
    }
  },
  AddIntermediateHoverLogic: (inst, CheckNextDaySetManually) => {
    const dateList = Calendar.getInvalidDays(inst);
    for (let f = 0; f < dateList.length; f++) {
      dateList[f].classList.remove("mystays-hover-intermediate");
    }
    for (let i = 0; i < dateList.length; i++) {
      dateList[i].addEventListener("mouseover", function() {
        // Remove class from existing elements
        for (let f = 0; f < dateList.length; f++) {
          dateList[f].classList.remove("mystays-hover-intermediate");
          const endVal = moment(inst.endVal).format("DD-MM-YYYY");
          const date = moment(dateList[f].getAttribute("data-full")).format(
            "DD-MM-YYYY"
          );
          if (endVal === date) {
            dateList[f].classList.remove("mbsc-selected");
            dateList[f].classList.remove("mbsc-cal-day-hl");
            dateList[f].classList.remove("mbsc-cal-sel-end");
          }
        }
        // Adding class from existing elements(rangeObject.endVal === "")
        for (let k = 0; k < dateList.length; k++) {
          const date1 = moment(
            dateList[k].getAttribute("data-full"),
            "YYYY-M-D"
          );
          const date2 = moment(
            dateList[i].getAttribute("data-full"),
            "YYYY-M-D"
          );
          const startVal = moment(inst.startVal);

          if (CheckNextDaySetManually && date1 >= startVal && date1 <= date2) {
            dateList[k].classList.add("mystays-hover-intermediate");
            Calendar.showToolTip(inst, null, date2);
          }
        }
      });
    }
  },
  customHTML: (event, langArray) => {
    const calendarContainer = event
      ? event.target.querySelector(".mbsc-fr-w")
      : document.querySelector(".mbsc-fr-w");
    const calendar = event
      ? event.target.querySelector(".mbsc-fr-c")
      : document.querySelector(".mbsc-fr-c");
    const noteContainer = event
      ? event.target.querySelector(".note")
      : document.querySelector(".note");
    if (noteContainer) {
      calendarContainer.removeChild(calendarContainer.lastElementChild);
    }
    calendar.insertAdjacentHTML(
      "afterend",
      `
        <div class="note">
          <span class="selected">${langArray.selected_date}</span>
          <span class="not-available">${langArray.not_available}</span>
          <span class="minimum">${langArray.minimum_stay}</span>
        </div>
      `
    );
  },
  customHeaderCalendar: (event, langArray) => {
    if (event.querySelectorAll(".mystays-bookingwidget-header").length > 0) {
      const customSelector = event.getElementsByClassName(
        "mystays-bookingwidget-header"
      );
      while (customSelector[0]) {
        customSelector[0].parentNode.removeChild(customSelector[0]);
      }
    }
    for (
      let index = 0;
      index <
      event.querySelectorAll(" .mbsc-cal-day-picker .mbsc-cal-table").length;
      index++
    ) {
      const sectionContainer = event.querySelectorAll(
        ".mbsc-cal-day-picker .mbsc-cal-table"
      )[index];
      const sectionStartDate = sectionContainer
        .querySelector("[data-full]")
        .getAttribute("data-full");

      let format = "MMM YYYY";
      let lang = event.lang;
      switch (event.lang) {
        case "ja":
          format = "YYYY年 MMM";
          break;
        case "ko":
          format = "YYYY일 MMM";
          break;
        case "zh":
          format = "YYYY年 MMM";
          lang = "zh-CN";
          break;
      }

      const headerText = moment(sectionStartDate, "YYYY M D")
        .locale(lang)
        .format(format);
      const sectionheader = document.createElement("div");
      sectionheader.className = "mystays-bookingwidget-header";
      sectionheader.innerHTML = `
              <div class="calendar__header">
                <span>${headerText}</span>
              </div>
              <div class="days">
                <span>${langArray.su}</span>
                <span>${langArray.M}</span>
                <span>${langArray.T}</span>
                <span>${langArray.W}</span>
                <span>${langArray.TH}</span>
                <span>${langArray.F}</span>
                <span>${langArray.S}</span>
              </div>
            `;
      sectionContainer.insertAdjacentHTML(
        "beforebegin",
        sectionheader.outerHTML
      );
    }
  },
  datePicker(_component, type) {
    const dateContainer = document.querySelector(`.mbsc-range-btn-${type}`);
    if (dateContainer) {
      const dateButton = dateContainer.querySelector(".mbsc-fr-btn-e");
      if (dateButton) {
        dateButton.click();
      }
    }
  },
  renderInvalidDate: (inst) => {
    const currentDays = Calendar.getCurrentDays(inst);
    currentDays.map((day) => {
      const selectdayStr = day.getAttribute("data-full");
      const selectDate = moment(selectdayStr, "YYYY-M-D").format("YYYY-MM-DD");
      Calendar.invalidDate.map((item) => {
        const invalidDate = moment(item).format("YYYY-MM-DD");
        if (selectDate === invalidDate) {
          day.classList.add("mystays-custom-invalid");
        }
      });
    });
  },
  renderInventory: (inst) => {
    const currentDays = Calendar.getCurrentDays(inst);

    currentDays.map((day) => {
      const inventory = day.querySelector(".inventory");
      if (inventory) {
        day.removeChild(inventory);
      }
    });

    currentDays.map((day) => {
      const dayData = day.getAttribute("data-full") || "";
      const isValid = day.classList.contains("mbsc-disabled");
      const currentDate = moment(dayData, "YYYY-M-D").format("YYYY-MM-DD");

      Calendar.inventory.map((item) => {
        const inventoryDate = moment(item.date).format("YYYY-MM-DD");
        if (dayData && !isValid && inventoryDate === currentDate) {
          const ivenHtml = document.createElement("span");
          ivenHtml.classList.add("inventory");
          ivenHtml.textContent = `${item.value}`;
          day.appendChild(ivenHtml);
        }
      });
    });
  },
  getAPICalendar: (payload, kidTiers = []) => {
    const { roomList } = payload;
    const response = myStaysAPI
      .getInventoryList(payload, kidTiers)
      .then((response) => {
        const data = response.map((resp) => {
          return resp.data.data;
        });

        let disabled_dates = [];
        let inventory = {};
        data.map((item) => {
          if (item.disabled_dates) {
            item.disabled_dates.forEach((disabledDate) => {
              disabled_dates.push(disabledDate);
            });
          }
          if (item.inventory) {
            inventory = Object.assign(inventory, item.inventory);
          }
        });

        Calendar.handleInvalidDate(disabled_dates);
        Calendar.handleInventory(inventory);
        return roomList.map((room) => {
          return {
            disabled_dates,
            inventory,
          };
        });
      })
      .catch((error) => {
        return {
          disabled_dates: [],
          inventory: {},
        };
      });

    return response;
  },
  handleInventory: (data) => {
    const inventoryDates = [];
    Object.keys(data).map((item) => {
      if (data[item] < 10) {
        inventoryDates.push({ date: item, value: data[item] });
      }
    });
    Calendar.inventory = inventoryDates;
  },
  handleInvalidDate: (data) => {
    Calendar.invalidDate = data;
  },
  onSetDate: (event, inst) => {
    const dateStr = event.valueText.split(" - ");
    const startDate = moment(dateStr[0]);
    const endDate = dateStr[1] ? moment(dateStr[1]) : "";

    if (endDate === "" || startDate > endDate) {
      const disableDay = Calendar.enableFirstDisableDate(inst, startDate);
      const nextDay = moment(startDate).add(1, "days");
      Calendar.disableDate = disableDay;

      if (startDate.diff(disableDay, "days") === 1) {
        inst.setVal([startDate, startDate], true, true, false);
      } else {
        inst.setVal([startDate, nextDay], true, true, false);
      }
      return true;
    } else if (
      Calendar.disableDate &&
      endDate.format("YYYY-MM-DD") > Calendar.disableDate.format("YYYY-MM-DD")
    ) {
      const disableDay = Calendar.enableFirstDisableDate(inst, endDate);
      const nextDay = moment(startDate).add(1, "days");
      Calendar.disableDate = disableDay;
      if (endDate.diff(disableDay, "days") === 1) {
        inst.setVal([endDate, endDate], true, true, false);
      } else {
        inst.setVal([endDate, nextDay], true, true, false);
      }
      inst.setActiveDate("end");
      return true;
    } else if (
      Calendar.disableDate &&
      endDate.format("YYYY-MM-DD") === Calendar.disableDate.format("YYYY-MM-DD")
    ) {
      return false;
    } else {
      return false;
    }
  },
  enableFirstDisableDate: (inst, startDate) => {
    const currentDays = Calendar.getCurrentDays(inst);
    Calendar.renderInvalidDate(inst);
    for (const day of currentDays) {
      day.classList.remove("open-invalid");
    }

    for (const day of currentDays) {
      const dayStr = day.getAttribute("data-full");
      const isDisableDate = day.classList.contains("mystays-custom-invalid");
      if (dayStr && isDisableDate && startDate < moment(dayStr)) {
        day.classList.remove("mystays-custom-invalid");
        day.classList.add("open-invalid");
        return moment(dayStr);
      }
    }
  },
};
export default Calendar;
